module.exports = __webpack_public_path__ + "img/ic_menu_white_24px.483f02dc.svg";